export default __webpack_public_path__ + "static/media/SimianDisplay-Chimpanzee.c599abb6.woff2";